module.exports = __webpack_public_path__ + "media/site_templates/www.skipbinhire.company/images/our_services_2-1295b5c016b77000e0148203cd0fd0f4.jpg";